import { enums } from '@kattana-io/common';
import {
  UPDATE,
  UPDATE_PARAMS,
  GET_NEXT_PAGE,
} from '../actions/modal_search';
import { ISort } from '../components/Modal/TickersModal/helper';

export enum EExchangeName {
  All = '',
  Binance = 'Binance',
  Uniswap = 'Uniswap',
  Pancakeswap = 'pancakeswap',
  hitbtc = 'hitbtc',
  sushiswap = 'sushiswap',
}
export enum ECurrentTab {
  SymbolSearch = 'Symbol Search',
  Watchlist = 'Watchlist',
}

export interface IModalSearch {
  tickers: any[];
  search: string;
  exchanges: EExchangeName[];
  currentTab: ECurrentTab;
  loading: boolean;
  isNextPageLoading: boolean;
  page: number;
  kind: enums.ETickerKind; // 1 - CEX, 2 - DEX, null - All
  sort?: ISort;
}

const defaultState = {
  tickers: [],
  search: '',
  exchange: EExchangeName.All,
  exchanges: [],
  currentTab: ECurrentTab.SymbolSearch,
  page: 0,
  kind: enums.ETickerKind.ALL,
  loading: true,
  isNextPageLoading: false,
};

const tickers_search = (state: IModalSearch = defaultState, action: any) => {
  switch (action.type) {
  case UPDATE:
    return {
      ...state,
      // loading: false,
      ...action.payload,
    };
  case GET_NEXT_PAGE:
    return {
      ...state,
      isNextPageLoading: true,
    };
  case UPDATE_PARAMS:
    return {
      ...state,
      ...action.payload,
      loading: true,
    };
  default:
    return state;
  }
};

export default tickers_search;
